<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Activité de la population</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <div class="col-12 tabs mt-0">
            <div class="tab {{tabs == 'country' ? 'active' : ''}}" (click)="toogleTabs('country')">
                Ville
            </div>
            <div class="tab {{tabs == 'quartier' ? 'active' : ''}}" (click)="toogleTabs('quartier')"
                 *ngIf="favorite.ad_city.mapping_quartier_iris && favorite.ad_city.mapping_quartier_iris.quartier">
                Quartier
            </div>
            <div class="tab {{tabs == 'compare' ? 'active' : ''}}" (click)="toogleTabs('compare')">
                Comparaison
            </div>
        </div>

        <img *ngIf="preview" src="assets/widgets/ss_activity.png" class="img-fluid"/>
        <app-upgrade-plan *ngIf="!authenticationService.isAllowed('basique')  && !preview"
                          plan="Basique" preview="assets/widgets/ss_activity.png"></app-upgrade-plan>
        <div class="card-text row"
             *ngIf="authenticationService.isAllowed('basique')  && !preview && data.series && data.series[0].data[0].value > 0">
            <div class="col-6" *ngIf="favorite.ad_city.mapping_quartier_iris && favorite.ad_city.mapping_quartier_iris.quartier && (tabs == 'quartier' || tabs == 'compare')">
                <mat-form-field>
                    <mat-label>Secteur</mat-label>
                    <mat-select disableOptionCentering [(ngModel)]="secteur" (ngModelChange)="edit($event, 'secteur')"
                                [disabled]="favorite.ad_city.mapping_quartier_iris == null || favorite.ad_city.mapping_quartier_iris.quartier == null || favorite.ad_city.mapping_quartier_iris.quartier.length == 1">
                        <mat-option value="">Toute la ville</mat-option>
                        <mat-option *ngFor="let group of favorite.ad_city.mapping_quartier_iris.quartier"
                                    [value]="group.GQ_c">{{ group.GQ_n }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-6" *ngIf="favorite.ad_city.mapping_quartier_iris && favorite.ad_city.mapping_quartier_iris.quartier && (tabs == 'quartier' || tabs == 'compare')">
                <mat-form-field>
                    <mat-label>Quartier</mat-label>
                    <mat-select disableOptionCentering [(ngModel)]="iris" (ngModelChange)="edit($event)"
                                [disabled]="cityService.getQuartier(favorite.ad_city, secteur).length == 0">
                        <mat-option [value]="secteur">Tous les quartiers</mat-option>
                        <mat-option *ngFor="let group of cityService.getQuartier(favorite.ad_city, secteur)"
                                    [value]="group.IRIS_c">{{ group.IRIS_n }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div *ngIf="tabs == 'country' || tabs == 'quartier'" echarts [options]="options" [merge]="data"
                 class="chart"></div>

            <table mat-table class="compare_table" [dataSource]="compare" *ngIf="tabs == 'compare'">
                <ng-container matColumnDef="lib">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        {{element.lib}}
                        <ng-container *ngIf="element.lib == 'Chomeurs'">
                            <i class="fa fa-question-circle" matTooltip="Le taux de chômage s’entend au sens du recensement.
Les valeurs obtenues sont souvent plus élevés que les chiffres communiqués par le gouvernement, car il utilisent le taux de chômage au sens du BIT (https://www.insee.fr/fr/metadonnees/definition/c1129)">
                            </i>
                        </ng-container>
                    </td>
                </ng-container>
                <ng-container matColumnDef="quartier">
                    <th mat-header-cell *matHeaderCellDef>Quartier</th>
                    <td mat-cell *matCellDef="let element"> {{element.quartier}}</td>
                </ng-container>
                <ng-container matColumnDef="secteur">
                    <th mat-header-cell *matHeaderCellDef>Secteur</th>
                    <td mat-cell *matCellDef="let element"> {{element.secteur}}</td>
                </ng-container>
                <ng-container matColumnDef="ville">
                    <th mat-header-cell *matHeaderCellDef>Ville</th>
                    <td mat-cell *matCellDef="let element"> {{element.ville}}</td>
                </ng-container>
                <ng-container matColumnDef="france">
                    <th mat-header-cell *matHeaderCellDef>France</th>
                    <td mat-cell *matCellDef="let element"> {{element.france}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </div>
        <p class="text-center no-data" *ngIf="data.series[0].data[0].value == 0">
            Pas de données
        </p>
        <p style="font-size: 10px;margin-top:-5px; margin-bottom: 0px; text-align: right;">
            Source : INSEE
        </p>
    </div>
</div>
